export const itemBankContentI18n = {
  itemBankContent: {
    errors: {
      accessDenied: 'You do not have access to the item bank admin views.',
    },
    actions: {
      retry: 'Retry',
      refresh: 'Refresh',
      view: 'View',
      exportCsv: 'Export CSV',
      showDetail: 'Show detail',
      hideDetail: 'Hide detail',
    },
    filters: {
      apply: 'Apply',
      dateFrom: 'From',
      dateTo: 'To',
    },
    columns: {
      id: 'ID',
      stem: 'Stem',
      domain: 'Domain',
      outcome: 'Outcome',
      author: 'Author',
      status: 'Status',
      version: 'Version',
      origin: 'Origin',
      updatedAt: 'Last updated',
      time: 'Time',
      actor: 'Actor',
      action: 'Action',
      entity: 'Entity',
      ip: 'IP',
      detail: 'Detail',
    },
    coverage: {
      empty: 'No blueprint domains exist yet for this program.',
      matrixTitle: 'Coverage matrix',
      total: 'Total',
      acceptedTotal: 'Accepted total',
      targetTbc: 'TBC',
      programTotal: 'Program total',
      waveColumnHeader: '{label} ({forms} forms)',
      wavesTitle: 'Form waves',
      wavesEmpty: 'No form waves exist yet. Set them up on the Blueprint tab.',
      waveFormsLabel: '{forms} forms',
      waveTargetDateLabel: 'Target date: {date}',
      waveTargetProgress: '{accepted} / {target}',
      waveDomainsBelowTarget: '{count} domain(s) below target',
      waveDomainsWithoutTarget: '{count} domain(s) without a target',
      waveStatusMet: 'Met',
      waveStatusCurrent: 'Current',
      waveStatusUpcoming: 'Upcoming',
      noOutcomesWarning: 'This domain has no mapped learning outcome. Items cannot be written against it.',
      smeTitle: 'Coverage by SME',
      smeEmpty: 'No SME assignments exist yet for this program.',
      quota: 'Quota',
      written: 'Written',
      inReview: 'In review',
      accepted: 'Accepted',
      rejected: 'Rejected',
      acceptanceRate: 'Acceptance rate',
      tierAchieved: 'Tier achieved',
      roundsTitle: 'Coverage by round',
      roundsEmpty: 'No writing rounds exist yet for this program.',
      round: 'Round',
      smeCount: 'SMEs',
      pendingDecision: 'Pending decision',
      projectedAccepted: 'Projected accepted',
      alignmentTitle: 'Learning outcome alignment',
      alignmentEmpty: 'No learning outcomes exist yet for this program.',
      text: 'Text',
      itemCount: 'Items',
      acceptedCount: 'Accepted',
      courseSections: 'Course sections',
      requirementsTitle: 'Regulatory coverage',
      requirementsEmpty: 'No regulatory requirements exist yet for this program.',
      jurisdiction: 'Jurisdiction',
      citation: 'Citation',
      topic: 'Topic',
      outcomes: 'Outcomes',
      inactiveOutcome: '{code} (inactive)',
      requirementStateCovered: 'Covered',
      requirementStateNoAcceptedItems: 'No accepted items',
      requirementStateOutcomeNotActive: 'Outcome not active',
      requirementStateNoOutcome: 'No outcome',
      gapsTitle: 'Blueprint gaps',
      domainsWithoutOutcomes: 'Domains with no mapped outcome',
      outcomesWithoutDomains: 'Outcomes mapped to no domain',
      outcomesWithoutItems: 'Outcomes with no items written',
      noGaps: 'No blueprint gaps found.',
      paymentInputsTitle: 'Payment inputs',
      paymentReadOnlyNotice: 'Read-only inputs for finance. Quality bonus threshold is {threshold} acceptance rate. '
        + 'Approval and payment happen outside this system.',
      paymentEmpty: 'No payment inputs exist yet for this program.',
      qualityBonus: 'Quality bonus eligible',
      quotaCompletedAt: 'Quota completed',
      yes: 'Yes',
      no: 'No',
      reviewInputsTitle: 'Review inputs',
      reviewInputsNotice: 'Read-only inputs for finance, one row per SME who has recorded review decisions. '
        + 'Approval and payment happen outside this system.',
      reviewInputsEmpty: 'No review inputs exist yet for this program.',
      contentReviews: 'Content reviews',
      biasReviews: 'Bias/sensitivity reviews',
      reviewsTotal: 'Reviews total',
      lastReviewedAt: 'Last reviewed',
    },
    items: {
      empty: 'No items match these filters.',
      search: 'Search',
      searchPlaceholder: 'ID, external ref or stem text',
      originAuthored: 'Authored',
      originImported: 'Imported',
      approvalPointer: 'Items are accepted by reviewers in the SME review queue, not from this page.',
      approvalPointerLink: 'Open the SME review queue',
    },
    itemDetail: {
      title: 'Item #{id}',
      version: 'Version {version}',
      content: 'Content',
      correct: 'Correct',
      rationale: 'Rationale',
      foodCodeRef: 'Food Code reference',
      cognitiveLevel: 'Cognitive level',
      aiAssistance: 'AI assistance',
      aiAssistanceNote: 'AI assistance note',
      metadata: 'Metadata',
      domain: 'Domain',
      outcome: 'Learning outcome',
      status: 'Status',
      externalRef: 'External reference',
      importBatch: 'Import batch',
      sourceAuthoredOn: 'Source authored on',
      submittedAt: 'Submitted',
      acceptedAt: 'Accepted',
      statusChangedAt: 'Status changed',
      revisionRequestedAt: 'Revision requested',
      reviews: 'Reviews',
      noReviews: 'No reviews recorded yet.',
      reviewType: 'Review type',
      decision: 'Decision',
      reviewer: 'Reviewer',
      reviewedVersion: 'Version reviewed',
      reviewedAt: 'Reviewed at',
      notes: 'Notes',
      revisionHistory: 'Revision history',
      noRevisions: 'No prior revisions.',
      changedBy: 'Changed by',
      changedAt: 'Changed at',
      changeNote: 'Change note',
      revisionTitle: 'Revision {version}',
      changeStatus: 'Change status',
      newStatus: 'New status',
      transitionNote: 'Note (required)',
      returnToAuthor: 'Return to author (draft)',
      returnToAuthorNote: 'Reason for returning to the author (required)',
      returnToAuthorHint: 'The author can edit and resubmit the item. Your reason is kept in the status history.',
      submitTransition: 'Submit',
      staleVersion: 'This item changed since it was loaded. The detail below has been reloaded with the current version.',
      statusHistory: 'Status history',
      statusHistoryEmpty: 'No status changes recorded yet.',
      statusHistoryFrom: 'From',
      statusHistoryTo: 'To',
      statusHistoryReason: 'Reason',
      auditTrail: 'Audit trail',
    },
    auditLog: {
      empty: 'No audit log entries match these filters.',
      entityType: 'Entity type',
      action: 'Action',
      entityId: 'Entity ID',
      systemActor: 'System',
      noDetail: '—',
    },
    importExport: {
      importTitle: 'Import',
      importNotice: 'Imported items are marked as imported rather than authored in the system.',
      downloadTemplate: 'Download template',
      chooseFile: 'CSV file',
      checkFile: 'Check file',
      importCount: 'Import {count} items',
      rowCount: 'Rows: {count}',
      validCount: 'Valid: {count}',
      duplicateWarning: 'This file matches a previous import batch: {filename} ({date}).',
      row: 'Row',
      messages: 'Messages',
      noErrors: 'No errors found. Ready to import.',
      importSuccess: 'Imported {count} items from {filename}.',
      confirmTitle: 'Import these items?',
      confirmBody: 'This will import {count} items. This cannot be undone from here.',
      confirmAction: 'Import',
      exportTitle: 'Export',
      exportNotice: 'Every download here is recorded in the audit log.',
      exportAccepted: 'Accepted items (ASC hand-off)',
      exportAll: 'Full development record',
      exportReviews: 'Reviews',
      exportPayments: 'Payment inputs',
      exportAuditLog: 'Audit log',
    },
  },
};

export const itemBankContentI18nEs = {
  itemBankContent: {
    errors: {
      accessDenied: 'No tienes acceso a las vistas de administración del banco de ítems.',
    },
    actions: {
      retry: 'Reintentar',
      refresh: 'Actualizar',
      view: 'Ver',
      exportCsv: 'Exportar CSV',
      showDetail: 'Mostrar detalle',
      hideDetail: 'Ocultar detalle',
    },
    filters: {
      apply: 'Aplicar',
      dateFrom: 'Desde',
      dateTo: 'Hasta',
    },
    columns: {
      id: 'ID',
      stem: 'Enunciado',
      domain: 'Dominio',
      outcome: 'Resultado',
      author: 'Autor',
      status: 'Estado',
      version: 'Versión',
      origin: 'Origen',
      updatedAt: 'Última actualización',
      time: 'Hora',
      actor: 'Actor',
      action: 'Acción',
      entity: 'Entidad',
      ip: 'IP',
      detail: 'Detalle',
    },
    coverage: {
      empty: 'Todavía no existen dominios de la tabla de especificaciones para este programa.',
      matrixTitle: 'Matriz de cobertura',
      total: 'Total',
      acceptedTotal: 'Total aceptado',
      targetTbc: 'Por definir',
      programTotal: 'Total del programa',
      waveColumnHeader: '{label} ({forms} formularios)',
      wavesTitle: 'Oleadas de formularios',
      wavesEmpty: 'Todavía no existen oleadas de formularios. Configúralas en la pestaña Tabla de especificaciones.',
      waveFormsLabel: '{forms} formularios',
      waveTargetDateLabel: 'Fecha objetivo: {date}',
      waveTargetProgress: '{accepted} / {target}',
      waveDomainsBelowTarget: '{count} dominio(s) por debajo del objetivo',
      waveDomainsWithoutTarget: '{count} dominio(s) sin objetivo',
      waveStatusMet: 'Cumplido',
      waveStatusCurrent: 'Actual',
      waveStatusUpcoming: 'Próxima',
      noOutcomesWarning: 'Este dominio no tiene un resultado de aprendizaje asignado. No se pueden escribir ítems para él.',
      smeTitle: 'Cobertura por experto en la materia',
      smeEmpty: 'Todavía no existen asignaciones de expertos en la materia para este programa.',
      quota: 'Cuota',
      written: 'Redactados',
      inReview: 'En revisión',
      accepted: 'Aceptados',
      rejected: 'Rechazados',
      acceptanceRate: 'Tasa de aceptación',
      tierAchieved: 'Nivel alcanzado',
      roundsTitle: 'Cobertura por ronda',
      roundsEmpty: 'Todavía no existen rondas de redacción para este programa.',
      round: 'Ronda',
      smeCount: 'Expertos',
      pendingDecision: 'Pendiente de decisión',
      projectedAccepted: 'Aceptados proyectados',
      alignmentTitle: 'Alineación de resultados de aprendizaje',
      alignmentEmpty: 'Todavía no existen resultados de aprendizaje para este programa.',
      text: 'Texto',
      itemCount: 'Ítems',
      acceptedCount: 'Aceptados',
      courseSections: 'Secciones del curso',
      requirementsTitle: 'Cobertura normativa',
      requirementsEmpty: 'Todavía no existen requisitos normativos para este programa.',
      jurisdiction: 'Jurisdicción',
      citation: 'Cita',
      topic: 'Tema',
      outcomes: 'Resultados',
      inactiveOutcome: '{code} (inactivo)',
      requirementStateCovered: 'Cubierto',
      requirementStateNoAcceptedItems: 'Sin ítems aceptados',
      requirementStateOutcomeNotActive: 'Resultado no activo',
      requirementStateNoOutcome: 'Sin resultado asignado',
      gapsTitle: 'Brechas de la tabla de especificaciones',
      domainsWithoutOutcomes: 'Dominios sin resultado asignado',
      outcomesWithoutDomains: 'Resultados sin dominio asignado',
      outcomesWithoutItems: 'Resultados sin ítems redactados',
      noGaps: 'No se encontraron brechas en la tabla de especificaciones.',
      paymentInputsTitle: 'Datos de pago',
      paymentReadOnlyNotice: 'Datos de solo lectura para finanzas. El umbral de bono de calidad es una tasa de aceptación de {threshold}. '
        + 'La aprobación y el pago se gestionan fuera de este sistema.',
      paymentEmpty: 'Todavía no existen datos de pago para este programa.',
      qualityBonus: 'Elegible para bono de calidad',
      quotaCompletedAt: 'Cuota completada',
      yes: 'Sí',
      no: 'No',
      reviewInputsTitle: 'Datos de revisión',
      reviewInputsNotice: 'Datos de solo lectura para finanzas, una fila por cada experto en la materia con decisiones de '
        + 'revisión registradas. La aprobación y el pago se gestionan fuera de este sistema.',
      reviewInputsEmpty: 'Todavía no existen datos de revisión para este programa.',
      contentReviews: 'Revisiones de contenido',
      biasReviews: 'Revisiones de sesgo/sensibilidad',
      reviewsTotal: 'Revisiones totales',
      lastReviewedAt: 'Última revisión',
    },
    items: {
      empty: 'Ningún ítem coincide con estos filtros.',
      search: 'Buscar',
      searchPlaceholder: 'ID, referencia externa o texto del enunciado',
      originAuthored: 'Redactado',
      originImported: 'Importado',
      approvalPointer: 'Los ítems son aceptados por los revisores en la cola de revisión de expertos, no desde esta página.',
      approvalPointerLink: 'Abrir la cola de revisión de expertos',
    },
    itemDetail: {
      title: 'Ítem #{id}',
      version: 'Versión {version}',
      content: 'Contenido',
      correct: 'Correcta',
      rationale: 'Justificación',
      foodCodeRef: 'Referencia al Código de Alimentos',
      cognitiveLevel: 'Nivel cognitivo',
      aiAssistance: 'Asistencia de IA',
      aiAssistanceNote: 'Nota sobre la asistencia de IA',
      metadata: 'Metadatos',
      domain: 'Dominio',
      outcome: 'Resultado de aprendizaje',
      status: 'Estado',
      externalRef: 'Referencia externa',
      importBatch: 'Lote de importación',
      sourceAuthoredOn: 'Redactado originalmente el',
      submittedAt: 'Enviado',
      acceptedAt: 'Aceptado',
      statusChangedAt: 'Estado modificado',
      revisionRequestedAt: 'Revisión solicitada',
      reviews: 'Revisiones',
      noReviews: 'Todavía no se han registrado revisiones.',
      reviewType: 'Tipo de revisión',
      decision: 'Decisión',
      reviewer: 'Revisor',
      reviewedVersion: 'Versión revisada',
      reviewedAt: 'Revisado el',
      notes: 'Notas',
      revisionHistory: 'Historial de revisiones',
      noRevisions: 'No hay revisiones anteriores.',
      changedBy: 'Modificado por',
      changedAt: 'Modificado el',
      changeNote: 'Nota del cambio',
      revisionTitle: 'Revisión {version}',
      changeStatus: 'Cambiar estado',
      newStatus: 'Nuevo estado',
      transitionNote: 'Nota (obligatoria)',
      returnToAuthor: 'Devolver al autor (borrador)',
      returnToAuthorNote: 'Motivo de la devolución al autor (obligatorio)',
      returnToAuthorHint: 'El autor puede editar y volver a enviar el ítem. Tu motivo queda en el historial de estados.',
      submitTransition: 'Enviar',
      staleVersion: 'Este ítem cambió desde que se cargó. El detalle a continuación se ha recargado con la versión actual.',
      statusHistory: 'Historial de estados',
      statusHistoryEmpty: 'Todavía no se han registrado cambios de estado.',
      statusHistoryFrom: 'Desde',
      statusHistoryTo: 'Hasta',
      statusHistoryReason: 'Motivo',
      auditTrail: 'Registro de auditoría',
    },
    auditLog: {
      empty: 'Ninguna entrada del registro de auditoría coincide con estos filtros.',
      entityType: 'Tipo de entidad',
      action: 'Acción',
      entityId: 'ID de entidad',
      systemActor: 'Sistema',
      noDetail: '—',
    },
    importExport: {
      importTitle: 'Importar',
      importNotice: 'Los ítems importados se marcan como importados en lugar de redactados en el sistema.',
      downloadTemplate: 'Descargar plantilla',
      chooseFile: 'Archivo CSV',
      checkFile: 'Verificar archivo',
      importCount: 'Importar {count} ítems',
      rowCount: 'Filas: {count}',
      validCount: 'Válidas: {count}',
      duplicateWarning: 'Este archivo coincide con un lote de importación anterior: {filename} ({date}).',
      row: 'Fila',
      messages: 'Mensajes',
      noErrors: 'No se encontraron errores. Listo para importar.',
      importSuccess: 'Se importaron {count} ítems desde {filename}.',
      confirmTitle: '¿Importar estos ítems?',
      confirmBody: 'Esto importará {count} ítems. Esta acción no se puede deshacer desde aquí.',
      confirmAction: 'Importar',
      exportTitle: 'Exportar',
      exportNotice: 'Cada descarga aquí queda registrada en el registro de auditoría.',
      exportAccepted: 'Ítems aceptados (entrega a ASC)',
      exportAll: 'Registro completo de desarrollo',
      exportReviews: 'Revisiones',
      exportPayments: 'Datos de pago',
      exportAuditLog: 'Registro de auditoría',
    },
  },
};
